declare const __APP_VERSION__: string;

export const GAME_CONFIG = {
  title: "Carole's Reef",
  version: __APP_VERSION__,
};
